import React, { useEffect, useContext, useState }  from 'react'
import { View, StyleSheet, FlatList, TouchableOpacity, ScrollView } from 'react-native'
import { Button, Text, Layout, Card } from '@ui-kitten/components'
import { UserContext } from '../../global/UserProvider'
import { format } from 'date-fns'
import HeaderIconButton from '../../components/HeaderIconButton'

export default function MarketingListsScreen( { navigation, route } ) {
  const [context, setContext] = useContext(UserContext)
  const db = context.db
  const [data, setData] = useState()

  
  useEffect(() => {

    if (['admin', 'manager'].includes(context.user.role)) {
      navigation.setOptions({
        headerRight: () => (
          <HeaderIconButton
            onPress={() => {
              navigation.navigate('CreateMarketingList')
            }}
            iconName='plus-outline'
          />
        ),
      })
    } 
    
    getData()

  }, [])

  const getData = async () => {
    var lists = []
    const querySnapshot = await db.collection('marketingLists').where('isDone', '==', false).get()
    querySnapshot.forEach(function(doc) {
      var snap = doc.data()
      snap.id = doc.id
      snap.ref = doc.ref
      lists.push(snap)
    })
    setData(lists)
  }

  const renderItem = ({item, index}) => (
    <Card onPress={() => navigation.navigate('MarketingListDetail', {marketingList: item})} style={{padding: 10, marginBottom: 5}}>
      <Text>{item.detail + ', ' + format(item.date.toDate(), 'd MMM y HH:MM') + ', ' + item.store}</Text>
    </Card>
  )
  
  return (
    <ScrollView>
      <FlatList
        style={{padding: 20}}
        data={data}
        renderItem={renderItem}
      />
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  
})